import { FunctionComponent } from 'react';
import { Stack, Typography } from '@monorepo/nova-ui';

interface Props {
  name: string;
  title: string;
  city: string;
  zipCode: string;
  country: string;
  street: string;
}

const BillCompanyDetails: FunctionComponent<Props> = ({
  name,
  title,
  city,
  zipCode,
  country,
  street,
}) => {
  const companyAddress = [city, zipCode, country].filter(Boolean).join(', ');

  return (
    <Stack>
      <Typography variant="body2">{name ? name + ',' : '-'}</Typography>
      <Typography variant="body2">{title ? title + ',' : '-'}</Typography>
      <Typography variant="body2">{street ? street + ',' : '-'}</Typography>
      {companyAddress && (
        <Typography variant="body2">{companyAddress}</Typography>
      )}
    </Stack>
  );
};

export default BillCompanyDetails;
